export enum ESelectorDisplayMode {
	list = "list",
	actionSheet = "action-sheet",
	alert = "alert",
	popover = "popover",
	tags = "tags"
}